/* 1654195a782ebfa8b688c6b831fc0991ffffd018
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HighlightCategoriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HighlightCategoriesQuery = { __typename?: 'Query', highlightCategories?: { __typename?: 'HighlightCategories', items?: Array<{ __typename?: 'HighlightCategory', featured_app_icon?: string | null, background_app_icon?: string | null, featured_icon?: string | null, featured_icon_solid?: string | null, name?: string | null, priority?: string | null, url?: string | null } | null> | null } | null };


export const HighlightCategoriesDocument = gql`
    query HighlightCategories {
  highlightCategories {
    items {
      featured_app_icon
      background_app_icon
      featured_icon
      featured_icon_solid
      name
      priority
      url
    }
  }
}
    `;

/**
 * __useHighlightCategoriesQuery__
 *
 * To run a query within a React component, call `useHighlightCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHighlightCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHighlightCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useHighlightCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<HighlightCategoriesQuery, HighlightCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HighlightCategoriesQuery, HighlightCategoriesQueryVariables>(HighlightCategoriesDocument, options);
      }
export function useHighlightCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HighlightCategoriesQuery, HighlightCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HighlightCategoriesQuery, HighlightCategoriesQueryVariables>(HighlightCategoriesDocument, options);
        }
export function useHighlightCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HighlightCategoriesQuery, HighlightCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HighlightCategoriesQuery, HighlightCategoriesQueryVariables>(HighlightCategoriesDocument, options);
        }
export type HighlightCategoriesQueryHookResult = ReturnType<typeof useHighlightCategoriesQuery>;
export type HighlightCategoriesLazyQueryHookResult = ReturnType<typeof useHighlightCategoriesLazyQuery>;
export type HighlightCategoriesSuspenseQueryHookResult = ReturnType<typeof useHighlightCategoriesSuspenseQuery>;
export type HighlightCategoriesQueryResult = Apollo.QueryResult<HighlightCategoriesQuery, HighlightCategoriesQueryVariables>;